import { Navigate, useRoutes } from "react-router-dom";
import DashboardLayout from "./layouts/dashboardLayout";
import MainLayout from "./layouts/mainLayout";
import Dashboard from "./pages/dashboard/dashboard";
import MyProfile from "./pages/dashboard/profile/profile";
import LandingPage from "./pages/landing/landing";
import DeveloperDetails from "./pages/marketPlace/developer/developerDetails";
import ProjectDetails from './pages/marketPlace/project/projectDetails';
import PropertyDetails from './pages/marketPlace/property/propertyDetails';
import Portfolio from "./pages/portfolio/portfolio";
import { checkLogin } from "./utils/functions";
// import InvestPage from "./pages/marketPlace/property/investPage";
import UrlShortner from "./helpers/urlShortner";
import HufRegistration from "./pages/dashboard/hufRegistration/hufRegistration";
import AssetOptin from "./pages/landing/assetOptin";
import InvestPage from "./pages/marketPlace/property/InvestPages/investPage";
import Transactions from "./pages/transactions/transactions";
import TrustRegistration from "./pages/trustRegistration/trustRegistration";
import { useSelector } from "react-redux";
import Wallet from "./pages/wallet/wallet";
import ReferralTrackingPage from "./pages/referrals/ReferralTrackingPage";

export default function Router() {
  const user = useSelector(state => state?.user?.data)
    return useRoutes([
      {
          path:'/',
          element:checkLogin() && user?.conditionAccepted ? <Navigate to="/dashboard" />: <MainLayout />,
          children:[
            {path:"",element:<LandingPage />},
            {path: "s/:propertyId", element: <UrlShortner />}
          ]
      },
      {
           path: "/optin/:id", element: <AssetOptin />
                 
      },
      {
            path:"lead/:distributorCode", element: <LandingPage />
      },
      {
        path:"lead/:distributorCode/:rm", element: <LandingPage />
      },
      { 
        path:"/dashboard",
        element:checkLogin()?<DashboardLayout />:<MainLayout />,
        children:[
          {path:"",element:checkLogin()?<Dashboard />:<Navigate to="/" replace />},
          {path:"profile",element:checkLogin()?<MyProfile />:<Navigate to="/" replace />},
          {path:"project",element:checkLogin()?<ProjectDetails />:<Navigate to="/" replace />},
          {path:"property",element:<Navigate to="/dashboard" />},
          {path:"property/:propertyId",element:<PropertyDetails />},
          {path:"property/:propertyId/invest",element:<InvestPage/>},
          // {path:"property2/:propertyId/invest",element:<InvestPage2 />},
          {path:"developer",element:checkLogin()?<DeveloperDetails />:<Navigate to='/' replace/>}
        ]
      },

      // {
      //   path:"/marketplace",<Navigate to="/" replace />
      //   element:checkLogin()?<DashboardLayout />:<MainLayout />,
      //   children:[
      //     {path:"",element: checkLogin() ? <MarketPlace /> :  },
      //     {path:"project",element: checkLogin() ? <ProjectDetails /> : <Navigate to="/" replace />},
      //     {path:"property",element:<Navigate to="/marketplace" replace />},
      //     {path:"property/:propertyId",element:<PropertyDetails />},
      //     {path:"property/:propertyId/invest",element:<InvestPage />},
      //     {path:"developer",element: checkLogin() ? <DeveloperDetails /> : <Navigate to="/" replace />}
      //   ]
      // },
      // {
      //   path:"/marketplace/property/invest",
      //   element:<InvestPage />
      // },
      {
        path:"/portfolio",
        element: checkLogin()
          ? <DashboardLayout />
          : <Navigate to='/' state={{ from: "/portfolio" }} replace />,
        children:[
          { path:"", element:<Portfolio /> }
        ]
      }
      ,
      // {
      //   path:"/transfer",
      //   element:checkLogin()?<DashboardLayout />:<Navigate to='/'/>,
      //   children:[
      //     {path:"",element:<Transfer />},
      //   ]
      // },
      {
        path:"/transactions",
        element:checkLogin()?
        <DashboardLayout />
        :<Navigate to='/' state={{ from: "/transactions" }} replace />,
        children:[
          {path:"",element:<Transactions />},
        ]
      },
      {
        path: "/wallet",
        element: checkLogin()
          ? <DashboardLayout />
          : <Navigate to='/' state={{ from: "/wallet" }} replace />,
        children: [
          { path: "", element: <Wallet /> },
        ]
      },
      {
        path:"/huf-registration",
        element:checkLogin()?<DashboardLayout />:<Navigate to='/'/>,
        children:[
          {path:"",element:<HufRegistration />},
        ]
      },
      {
        path:"/trust-registration",
        element:checkLogin()?<DashboardLayout />:<Navigate to='/'/>,
        children:[
          {path:"",element:<TrustRegistration />},
        ]
      },
      {
        path: "/referrals",
        element: checkLogin()
          ? <DashboardLayout />
          : <Navigate to="/" state={{ from: "/referrals" }} replace />,
        children: [
          { path: "", element: <ReferralTrackingPage /> },
        ],
      },
      
      { path: '*', element: <Navigate to="/" replace /> },
      // { path: '*', element: <Navigate to="/404" replace /> },
    ]);
  }